// CategoriesSection.js
import React from "react";
import category_img from "../../Assets/category-default.png";
import "./CategoriesSection.css";

const CategoriesSection = ({ categories, onCategoryClick }) => (
  <div className="home-categories-section">
    {/* Animated background elements */}
    <div className="home-categories-bg-glow"></div>
    <div className="home-categories-bg-grid"></div>

    <div className="home-categories-container">
      <div className="home-categories-header">
        <div className="home-categories-badge">
          <span className="home-categories-badge-icon">✦</span>
          <span>Curated Collections</span>
        </div>
        <h2 className="home-categories-title">
          Our Top
          <span className="home-categories-title-gradient"> Categories</span>
        </h2>
        <p className="home-categories-subtitle">
          Explore expertly curated collections designed to inspire your next project
        </p>
      </div>

      <div className="home-categories-grid">
        {categories.map((cat, idx) => (
          <div
            key={cat.category_id}
            className="home-category-card"
            onClick={() => onCategoryClick(cat)}
            style={{ transitionDelay: `${idx * 50}ms` }}
          >
            <div className="home-category-card-inner">
              <div className="home-category-image">
                <img
                  src={cat.image || category_img}
                  alt={cat.category_name}
                  loading="lazy"
                />
                <div className="home-category-image-overlay"></div>
                <div className="home-category-shine"></div>
              </div>
              <div className="home-category-info">
                <div className="home-category-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 7L4 7" strokeLinecap="round"/>
                    <path d="M20 12L8 12" strokeLinecap="round"/>
                    <path d="M20 17L4 17" strokeLinecap="round"/>
                    <circle cx="7" cy="7" r="2"/>
                    <circle cx="11" cy="12" r="2"/>
                    <circle cx="7" cy="17" r="2"/>
                  </svg>
                </div>
                <h5 className="home-category-name">{cat.category_name}</h5>
              </div>
              <div className="home-category-hover-line"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default CategoriesSection;